// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e6d9f3a4","455":"00a8a168","977":"14a60deb"}[chunkId] + ".chunk.js";
};